import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LocaleContext from "../../../i18n/LocaleContext";

const ResumeDialog = ({ open, user, onResume, onStartOver }) => {
  const t = React.useContext(LocaleContext);
  return (
    <Dialog
      open={!!open}
      aria-labelledby="resume-dialog-title"
      aria-describedby="resume-dialog-description"
    >
      <DialogTitle id="resume-dialog-title">
        {t("Continue where you left off?")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            "We see that you've already started an application. Would you like to continue where you left off?"
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onStartOver} color="primary">
          {t("Start a New Application")}
        </Button>
        <Button
          size="small"
          onClick={() => onResume(user)}
          variant="contained"
          color="secondary"
        >
          {t("Resume Application")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResumeDialog;
